import currencies from './currencies.json';

const GetSymbol = (currency) => {
    return currencies[currency] || currency
}

const Currencies = {
    GetSymbol,
    GetList : () => currencies  
}

export default Currencies;